// extracted by mini-css-extract-plugin
module.exports = {"wrap":"yj","articleImagesWrap":"zj","articleImage":"Aj","singleImage":"Bj"};